// 查询操作日志列表
import request from '@/utils/request'

// 查询推送信息日志列表
export function interfaceLogList (data) {
  return request({
    url: '/external/externalInterfaceCallRecord/list',
    method: 'post',
    data: data
  })
}

// 日志重推
export function rePush (data) {
  return request({
    url: '/external/externalInterfaceCallRecord/rePush',
    method: 'post',
    data: data
  })
}

// 更新状态
export function updateStatusApi (data) {
  return request({
    url: '/external/externalInterfaceCallRecord/updateStatus',
    method: 'post',
    data: data
  })
}

// 重推工单
export function pushWorkOrderListApi (data) {
  return request({
    url: '/mq-fpl/mesDiscreteJobsFpl/pushWorkOrderList',
    method: 'post',
    data: data
  })
}
